export const TOLERANCE_VAL = 50;
export const TOLERANCE_QTY = 1;
export const CASH_TOL = 5;

export const STATUS = {
  MATCHED: { label: 'Matched', color: '#34d399' },
  VAL_BREAK: { label: 'Value Break', color: '#fbbf24' },
  QTY_BREAK: { label: 'Position Qty Break', color: '#f87171' },
  MISSING_CP: { label: 'Missing from Milliman', color: '#a78bfa' },
  MISSING_BOR: { label: 'Missing from Clearwater', color: '#38bdf8' },
};

export const STATUS_ORDER = ['MATCHED', 'VAL_BREAK', 'QTY_BREAK', 'MISSING_CP', 'MISSING_BOR'];

export const STATUS_CASH = {
  MATCHED: { label: 'Matched', color: '#34d399' },
  VAL_BREAK: { label: 'Amount Break', color: '#fbbf24' },
  AMBIGUOUS: { label: 'Ambiguous Match', color: '#a78bfa' },
  MISSING_BOR: { label: 'Missing from Custody', color: '#38bdf8' },
  MISSING_CP: { label: 'Unmatched in Custody', color: '#f87171' },
};

export const STATUS_CASH_ORDER = ['MATCHED', 'VAL_BREAK', 'AMBIGUOUS', 'MISSING_BOR', 'MISSING_CP'];
